module.exports = __webpack_public_path__ + "img/superman.8c9cad00.gif";